import { createWsActions, WsPrefixes, send } from '@skynet/data-ws-core';
import type { WsCommand } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.mmPrefix;

const mmActions = createWsActions(prefix);

export const {
  actionConnect,
  actionOnOpen,
  actionDisconnect,
  actionOnClose,
  actionOnClosed,
  actionSend,
  actionOnMessage,
  actionOnBroken,
  actionOnReconnectBegin,
  actionOnReconnectAttempt,
  actionOnReconnected,
  actionOnError,
} = mmActions;

export { mmActions };

/** Dispatches a WS send action with the MM prefix. */
export const wsMmSend = (message: WsCommand) => send(message, prefix);
